// extracted by mini-css-extract-plugin
export default {"wrapper":"es8AcP__weyVwguJnC23"};